import {
  AllStateUrl,
  AllCityUrl,
  DealerCompanyBaseProductPriceUrl,
} from '../api';
import { axios } from '../../../utils/settings';
import { getToken, getTokenHeader } from './index';

export const GetAllStates = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    let params = { params: {} };
    if (token) {
      params = { params: {}, ...getTokenHeader(token) };
    } else {
      params = { params: {} };
    }
    await axios
      .get(AllStateUrl(), params)
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};
export const GetAllCityOfState = async (stateId) => {
  return new Promise(async (next) => {
    let token = await getToken();
    let params = { params: {} };
    if (token) {
      params = { params: {}, ...getTokenHeader(token) };
    } else {
      params = { params: {} };
    }

    await axios
      .get(`${AllCityUrl()}/${stateId}`, params)
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        next({ error: error });
      });
  });
};
export const CompaniesBaseProductPrice = async (id, useresiId) => {
  return new Promise(async next => {
    let token = await getToken();
    await axios
      .get(`${DealerCompanyBaseProductPriceUrl()}?company_id=${id}&user_esi_id=${useresiId}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({data: x}) => {
        return next(x);
      })
      .catch(function (error) {
        return next({error: error});
      });
  });
};